import { render, staticRenderFns } from "./ExhibitionTable.vue?vue&type=template&id=608702dc&scoped=true&"
import script from "./ExhibitionTable.vue?vue&type=script&lang=js&"
export * from "./ExhibitionTable.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionTable.vue?vue&type=style&index=0&id=608702dc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608702dc",
  null
  
)

export default component.exports